var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"theframe",staticStyle:{"border":"0","position":"absolute","height":"100%","width":"100%","left":"0","top":"0"},attrs:{"src":_vm.reportslug},on:{"load":_vm.onIFrameLoad}})}
var staticRenderFns = []

export { render, staticRenderFns }